<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new cargo entry</small>
      </legend>

      <div>
        <form @submit.prevent="newCargos()">
          <div class="row">
            <input type="hidden" class="fileopening_id" :value="Fileopening.id" />
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Cargo number</th>
                    <th scope="col">Cargo size</th>
                    <th scope="col">Net weight</th>
                    <th scope="col">Weight units</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(SystemCargo, k) in systemcargosRows" :key="k">
                    
                    <td scope="row">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="deleteRow(k, SystemCargo)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control container_no input-rounded f-s-14"
                        v-model="SystemCargo.container_no"
                        placeholder="cargo number"
                        required
                      />
                    </td>
                    <td>
                      <select
                        name="cargo_size"
                        class="form-control cargo_size input-rounded f-s-14"
                        v-model="SystemCargo.cargo_size"
                      >
                        <option value>Select cargo size</option>
                        <option value="20">1X20</option>
                        <option value="40">1X40</option>
                        <option value="LCL">LCL</option>
                        <option value="OOG">OOG</option>
                        <option value="UNITS">UNITS</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control net_weight input-rounded f-s-14"
                        v-model="SystemCargo.net_weight"
                        placeholder="net weight of cargo"
                        
                      />
                    </td>
                    <td>
                      <select
                        name="weight_units"
                        class="form-control weight_units input-rounded f-s-14"
                        v-model="SystemCargo.weight_units"
                      >
                        <option value>Select weight units</option>
                        <option value="TONNES">TONNES</option>
                        <option value="KG">KG</option>
                        <option value="PACKAGES">PACKAGES</option>
                        <option value="DRUM">DRUM</option>
                      </select>
                    </td>
                  </tr>
                  <tr v-show="systemcargosRows.length === 0">
                    <td colspan="6">
                      <p class="text-center alert-danger p-2">No cargos added/available.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <button type="button" class="btn btn-info" @click="addCargoEntry">
            <i class="fa fa-plus-circle"></i>
            Add row
          </button>
          <button type="submit" class="btn btn-primary btn-flat creatingCargo btn-rounded">
            <i class="fa fa-plus"></i> submit cargo
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingCargoLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Fileopening.length === 0) {
      router.push("/managefileopenings");
    }
  },
  computed: {
    ...mapGetters(["Fileopening", "systemcargosRows"])
  },
  methods: {
    ...mapActions(["newCargos"]),
    ...mapMutations(["addCargoEntry"]),
    deleteRow(index, SystemCargo) {
      var idx = this.systemcargosRows.indexOf(SystemCargo);
      console.log(idx, index);
      if (idx > -1) {
        this.systemcargosRows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  }
};
</script>
<style scoped>
.creatingCargoLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/cargoentries/cargoentry.vue